<template>
  <section class="f-1" id="home">
    <m-img class="kv_bg" src="@/v2/pad_auto/assets/images/kv_bg.jpg" />
    <kv_title class="kv_title" />
    <VideoMask :videoSrc="videoSrc">
      <div class="promotional_btn" ref="promotional">
        观看宣传片
        <VideoPlay />
      </div>
    </VideoMask>
  </section>
</template>
<script lang="ts">
import VideoMask from '@/components/video-mask.vue'
import VideoPlay from '@/v2/auto/assets/image/0/video_play.vue'
import videoSrc from '@/v2/auto/assets/video/0/0.mp4'
import kv_title from '../assets/images/kv_title.vue'
export default {
  components: {
    kv_title,
    VideoMask,
    VideoPlay,
  },
  data() {
    return {
      videoSrc,
      preload_: true,
    }
  },
}
</script>
<style lang="less">
.f-1 {
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 90;
  background-color: #000;
  display: flex;
  justify-content: center;

  .kv_bg {
    position: absolute;
    object-fit: cover;
    object-position: bottom;
    width: 100%;
    height: 100%;
  }
  .kv_title {
    position: relative;
    height: 8rem;
    z-index: 1;
    top: 20%;
  }
  .promotional_btn {
    position: absolute;
    z-index: 1;
    font-size: 18px;
    color: #000;
    width: 160px;
    border-radius: 100px;
    background-color: #ffffffcf;
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
    padding: 12px 0;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
</style>
